import Vue from 'vue'
import Router from 'vue-router'
import { requireAuth } from '@/utils/auth'
import Login from '../components/Login'
import Reporting from '../components/Reporting'
import Confirmation from '../components/Confirmation'
import Reported from '../components/Reported'
import PaymentHistory from '../components/PaymentHistory'
import Instructions from '../components/Instructions'
import NoReporting from '../components/NoReporting'
import ContactUs from "../components/ContactUs";

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Login',
            component: Login
        },
        {
            path: '/noreporting',
            name: 'NoReporting',
            beforeEnter: requireAuth,
            component: NoReporting
        },
        {
            path: '/reporting',
            name: 'Reporting',
            beforeEnter: requireAuth,
            component: Reporting
        },
        {
            path: '/confirmation',
            name: 'Confirmation',
            beforeEnter: requireAuth,
            component: Confirmation
        },
        {
            path: '/reported',
            name: 'Reported',
            beforeEnter: requireAuth,
            component: Reported
        },
        {
            path: '/history',
            name: 'PaymentHistory',
            beforeEnter: requireAuth,
            component: PaymentHistory
        },
        {
            path: '/instructions',
            name: 'Instructions',
            beforeEnter: requireAuth,
            component: Instructions
        },
        {
            path: '/contactus',
            name: 'ContactUs',
            beforeEnter: requireAuth,
            component: ContactUs
        }
    ],
    // Provides capability for scrolling the page to a specified anchor.
    scrollBehavior (to) {
        if (to.hash) {
            return { selector: to.hash }
        }
    }
})
